import axios from 'axios';
import React from 'react';
import { HashLink } from 'react-router-hash-link';
import { ANCHOR_IDS } from '@constants/anchorIds';
import { Banner, Button, Icon, Toasts, Tooltip } from '@fourthwall/components';
import { RefreshIcon, TickIcon } from '@fourthwall/icons';
import { routing } from '@utils/routing';
import * as S from './MailchimpAudienceConnected.styled';
export const MailchimpAudienceConnected = ({ listId, createStore, isCreatingStore, createSyncJob, isCreatingSyncJob, hasSynced, abandonedCheckoutIsOff, }) => {
    const handleCreateStore = async (listId) => {
        try {
            await createStore(listId);
        }
        catch (error) {
            if (axios.isAxiosError(error) && error.response?.status === 403) {
                Toasts.notify('Access denied. This is likely because you have too many lists or stores in your Mailchimp account. Please try going through and deleting some.', { type: 'error' });
            }
            else {
                Toasts.notify('Failed to refresh Mailchimp lists. Please try again.', { type: 'error' });
                console.error('Failed to create Mailchimp store:', error);
            }
        }
    };
    return (React.createElement(S.Container, null,
        React.createElement(S.Title, null,
            React.createElement(Icon, { component: TickIcon, width: 24, height: 24 }),
            React.createElement("div", null, "Successfully Connected to Mailchimp")),
        React.createElement(S.Description, null,
            React.createElement("p", null, "Your Fourthwall audience is now connected to Mailchimp without e-commerce features. You can now manage your email subscribers and create engaging email campaigns to connect with your community."),
            React.createElement("p", null, "Ecommerce features such as Promotions, Products, and Orders are not available. Once you do upgrade to a Standard account, you can use the button below to access these features.")),
        React.createElement(S.ButtonContainer, null,
            React.createElement(Button, { label: "Reconnect with E-commerce features", appearance: "secondary", onClick: () => handleCreateStore(listId), loading: isCreatingStore, disabled: isCreatingStore })),
        React.createElement(S.SyncSection, null,
            React.createElement(Tooltip, { reference: React.createElement(Button, { label: "Sync Now", appearance: "primary", size: "medium", leftIcon: React.createElement(Icon, { component: RefreshIcon, width: 16, height: 16 }), onClick: createSyncJob, loading: isCreatingSyncJob, disabled: isCreatingSyncJob || hasSynced }) }, hasSynced ? 'Your data was recently synced.' : undefined)),
        !abandonedCheckoutIsOff && (React.createElement(Banner, { appearance: "warning" },
            "Fourthwall's default abandoned cart emails are turned on. If you're using Mailchimp to send abandoned cart emails make sure to",
            ' ',
            React.createElement(HashLink, { to: {
                    pathname: routing.settings.checkout,
                    hash: ANCHOR_IDS.ABANDONED_CHECKOUT_REMINDERS,
                } }, "disable Fourthwall cart abandonment emails"),
            "."))));
};
